// extracted by mini-css-extract-plugin
export var button = "_5b-0";
export var icon = "_5b-1";